export interface WidgetSpec {
  widget_id: string;
  table: string;
  is_json: boolean;
  plan: Record<string, string>;
  source: 'llm' | 'user';
  added_at: string;
}

export async function apiAddWidget(type: string, prompt: string): Promise<{ widget: Record<string, unknown> }> {
  const res = await fetch('/api/dashboard/layout/widget', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, prompt }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

export async function apiRemoveWidget(widgetId: string): Promise<void> {
  const res = await fetch(`/api/dashboard/layout/widget/${widgetId}`, { method: 'DELETE' });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
}

export async function apiResetLayout(): Promise<void> {
  const res = await fetch('/api/dashboard/layout/reset', { method: 'POST' });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
}

export async function apiUpdateFilterVisibility(hidden: string[]): Promise<void> {
  const res = await fetch('/api/dashboard/layout/filters/visibility', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ hidden }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
}

export async function apiUpdateFilterOrder(order: string[]): Promise<void> {
  const res = await fetch('/api/dashboard/layout/filters/order', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ order }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
}

export async function apiResetFilters(): Promise<void> {
  const res = await fetch('/api/dashboard/layout/filters/reset', { method: 'POST' });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
}

export async function apiAdminAddTenantWidget(type: string, prompt: string): Promise<{ widget: Record<string, unknown> }> {
  const res = await fetch('/api/dashboard/tenant-default/widget', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, prompt }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

export async function apiUpdateWidgetType(widgetId: string, type: string): Promise<void> {
  const res = await fetch(`/api/dashboard/layout/widget/${widgetId}/type`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
}

export async function apiAdminUpdateTenantWidgetType(widgetId: string, type: string): Promise<void> {
  const res = await fetch(`/api/dashboard/tenant-default/widget/${widgetId}/type`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
}

export async function apiAdminSetTenantWidgets(widgetIds: string[]): Promise<void> {
  const res = await fetch('/api/dashboard/tenant-default/widgets', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ widget_ids: widgetIds }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
}

export async function apiAdminSetTenantFilters(filterIds: string[]): Promise<void> {
  const res = await fetch('/api/dashboard/tenant-default/filters', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ filter_ids: filterIds }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
}
